import { render, staticRenderFns } from "./WoundDetail.vue?vue&type=template&id=5c9b7218&scoped=true&"
import script from "./WoundDetail.vue?vue&type=script&lang=js&"
export * from "./WoundDetail.vue?vue&type=script&lang=js&"
import style0 from "./WoundDetail.vue?vue&type=style&index=0&id=5c9b7218&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9b7218",
  null
  
)

export default component.exports